import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { qaApi } from "../../../services/api/qaApi";
import { FiHelpCircle, FiArrowUp, FiEye, FiAward } from "react-icons/fi";
import "./widgets.css";

const UnansweredQuestions = ({ onQuestionClick }) => {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState("recent");

  useEffect(() => {
    loadUnansweredQuestions();
  }, [sortBy]);

  const loadUnansweredQuestions = async () => {
    try {
      setLoading(true);
      const response = await qaApi.getUnansweredQuestions({
        limit: 10,
        offset: 0,
        sortBy,
      });

      if (response.data.success) {
        setQuestions(response.data.questions || []);
      }
    } catch (error) {
      // Silent fail - widget is not critical
    } finally {
      setLoading(false);
    }
  };

  const handleQuestionClick = (questionId) => {
    if (onQuestionClick) {
      onQuestionClick(questionId);
    } else {
      navigate(`/posts/${questionId}`);
    }
  };

  if (loading) {
    return (
      <div className="cbx-widget cbx-widget--unanswered">
        <div className="cbx-widget__header">
          <h3 className="cbx-widget__title">
            <FiHelpCircle className="cbx-widget__title-icon" />
            Unanswered
          </h3>
        </div>
        <div className="cbx-widget__loading">Loading...</div>
      </div>
    );
  }

  if (questions.length === 0) {
    return (
      <div className="cbx-widget cbx-widget--unanswered">
        <div className="cbx-widget__header">
          <h3 className="cbx-widget__title">
            <FiHelpCircle className="cbx-widget__title-icon" />
            Unanswered
          </h3>
        </div>
        <div className="cbx-widget__empty">
          <FiHelpCircle className="cbx-widget__empty-icon" />
          <p className="cbx-widget__empty-text">
            No unanswered questions right now!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="cbx-widget cbx-widget--unanswered">
      <div className="cbx-widget__header">
        <h3 className="cbx-widget__title">
          <FiHelpCircle className="cbx-widget__title-icon" />
          Unanswered
        </h3>
      </div>

      <div className="cbx-questions-list">
        {questions.slice(0, 5).map((question) => {
          const score =
            (question.question?.upvotes?.length || 0) -
            (question.question?.downvotes?.length || 0);
          const bounty = question.question?.bounty || 0;
          const views = question.question?.views || 0;

          return (
            <div
              key={question._id}
              className="cbx-question-item"
              onClick={() => handleQuestionClick(question._id)}
            >
              <h4 className="cbx-question-title">
                {question.question?.title || "Question"}
              </h4>

              <div className="cbx-question-stats">
                <span className="cbx-question-stat">
                  <FiArrowUp />
                  {score}
                </span>
                <span className="cbx-question-stat">
                  <FiEye />
                  {views}
                </span>
                {bounty > 0 && (
                  <span className="cbx-question-stat cbx-question-stat--bounty">
                    <FiAward />+{bounty}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className="cbx-widget__footer">
        <Link to="/questions/unanswered" className="cbx-widget__footer-link">
          See All Unanswered →
        </Link>
      </div>
    </div>
  );
};

export default UnansweredQuestions;
